<div class="site-header__search js-site-header-search">
	<div class="search-box site-header__search-box" ref="searchBox">
		<input type="text" class="quick-search-box__input" @keyup="inputKeyUp" @keyup.enter="submitSearch" ref="searchInput" placeholder="What are you looking for?">
		<button class="quick-search-box__btn quick-search-box__submit" ref="searchButton" @click="submitSearch">
			<i class="icon-search2"></i> <span class="sr-only">{{translations['Sayt.Search']}}</span>
		</button>
	</div>
	<div class="sub-nav site-header__search-results quick-search-results js-quick-search-results" ref="searchResults">
		<div class="quick-search-results__close" @click="hideSearchResultsPanel"><span class="icon-times"></span></div>
		<div class="quick-search-results__body">
			<div class="quick-search-results__panel">
				<h5 class="quick-search-results__category-header">{{translations['Sayt.Products']}}</h5>
				<template v-if="!products.length">
					<div class="quick-search-results__no-results">{{translations['Sayt.NoResultsFound']}}</div>
				</template>
				<template v-else>
					<ul class="quick-search-results__matching-products">
						<template v-for="product in products">
							<li class="quick-search-results__matching-product product-result">
								<product-search-card
									:displayName="product.displayName"
									:additionalDisplayName="product.additionalDisplayName"
									:stockNumber="product.stockNumber"
									:primaryImageUrl="product.primaryImageUrl"
									:url="product.url"
									:highlightResults="product.highlightResults"
								/>
							</li>
						</template>
					</ul>
					<a :href="moreProductsLink" class="quick-search-results__view-all">{{translations['Sayt.ViewAllMatchingProducts']}} <i class="icon-arrow-circle-right"></i></a>
				</template>
			</div>
			<div class="quick-search-results__panel">
				<h5 class="quick-search-results__category-header">{{translations['Sayt.Pages']}}</h5>
				<template v-if="!pages.length">
					<div class="quick-search-results__no-results">{{translations['Sayt.NoResultsFound']}}</div>
				</template>
				<template v-else>
					<ul class="quick-search-results__matching-pages">
						<template v-for="page in pages">
							<li class="quick-search-results__matching-page pages-result">
								<pages-search-card
									:title="page.title"
									:url="page.url"
									:highlightResults="page.highlightResults"
									:imageUrl="page.imageUrl"
									:contentType="page.contentType"
									:contentTypeDisplay="page.contentTypeDisplay"
								/>
							</li>
						</template>
					</ul>
					<a :href="morePagesLink" class="quick-search-results__view-all">{{translations['Sayt.ViewAllMatchingPages']}} <i class="icon-arrow-circle-right"></i></a>
				</template>
			</div>
			<div class="quick-search-results__panel">
				<div class="quick-search-results__category-header"><i class="icon-creators-corner"></i><span class="sr-only">{{translations['Sayt.ProjectResults']}}</span></div>
				<template v-if="!projects.length">
					<div class="quick-search-results__no-results">{{translations['Sayt.NoResultsFound']}}</div>
				</template>
				<template v-else>
					<ul class="quick-search-results__matching-projects">
						<template v-for="project in projects">
							<li class="quick-search-results__matching-project project-result">
								<project-search-card
									:imageUrl="project.imageUrl"
									:title="project.title"
									:url="project.url"
									:highlightResults="project.highlightResults"
								/>
							</li>
						</template>
					</ul>
					<a :href="moreProjectsLink" class="quick-search-results__view-all">{{translations['Sayt.ViewAllMatchingProjects']}} <i class="icon-arrow-circle-right"></i></a>
				</template>
			</div>
		</div>
	</div>
</div>
